module.exports = __webpack_public_path__ + "static/media/slide-2mr.6a650ff1.jpg";